import React, { PureComponent } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Accordion from '@mui/material/Accordion';
import { ExpandMore } from '@mui/icons-material';
import { withStyles } from 'tss-react/mui';

const styles = () => ({
  panelDetailsStyle: { display: 'contents' },
  panelSummaryStyle: {},
});

const withExpansionPanel = (
  WrappedComponent,
  options = {
    elevation: 2
  }
) => withStyles((class extends PureComponent {
  state = {
    expanded: !!this.props.expanded,
  };

  render() {
    const {
      expansionTitle,
      summaryChild,
      classes: {
        panelSummaryStyle,
        panelDetailsStyle,
        ...classes
      },
      noMargin,
      elevation = options.elevation,
      ...otherProps
    } = this.props;
    const { expanded } = this.state;
    return (
      <Box
        sx={{ mb: noMargin ? 0 : 1 }}
      >
        <Accordion
          elevation={elevation}
          onChange={() => this.setState({ expanded: !expanded })}
          expanded={expanded}
        >
          <AccordionSummary
            className={panelSummaryStyle}
            expandIcon={<ExpandMore />}
            children={summaryChild ||
                <Typography variant="subtitle1" children={expansionTitle} />
            }
          />
          <AccordionDetails className={panelDetailsStyle}>
            {expanded &&
                <WrappedComponent
                  classes={classes}
                  expansionTitle={expansionTitle}
                  {...otherProps}
                />
            }
          </AccordionDetails>
        </Accordion>
      </Box>
    );
  }
}), styles);

export default withExpansionPanel;
